import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Button,
  Form,
  Input,
  notification,
  Divider,
  Breadcrumb,
  Tabs,
  Radio,
  Space,
} from "antd";
import { Link, useHistory } from "react-router-dom";
import { MessageFilled, UserOutlined, LockFilled } from "@ant-design/icons";
import LandingPageAppBar from "../../components/LandingPageAppBar";
import Footer from "../../components/common/Footer";
import MobileFooter from "../../components/common/MobileFooter";
import { updateProfileAction } from "../../redux/actions/authActions";
import { decode as tokenDecoder } from "../../utils/tokenDecoder";

const { TabPane } = Tabs;

const Login = ({ updateProfileAction, auth }) => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const onPasswordFinish = (values) => {
    const { password } = values;
    updateProfileAction({ password });
  };

  const onProfileFinish = (values) => {
    setLoading(true);
    updateProfileAction(values);
  };

  useEffect(() => {
    if (auth.profile.updateProfileData) {
      notification.success({ message: "Profile updated successfully" });

      localStorage.setItem("x-auth-token", auth.profile.updateProfileData.data);

      setLoading(false);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      // 
    }
    if (auth.profile.updateProfileError) {
      notification.error({ message: auth.profile.updateProfileError?.error });
      setLoading(false);
    }
  }, [auth.profile]);

  //   Decode token
  const token = localStorage.getItem("x-auth-token");
  const userData = token && tokenDecoder(token);
  return (
    <div className="page-container">
      <LandingPageAppBar />
      <div className="child-container">
        <div className="container-dft-margin">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/home">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/account/settings">Account Settings</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="container-center">
          <div className="card form-container">
            <Tabs tabPosition={"left"}>
              <TabPane tab="Account Settings" key="1">
                <Form
                  layout="vertical"
                  hideRequiredMark
                  onFinish={onProfileFinish}
                  className="mb-4"
                  initialValues={{
                    firstName: userData.firstName,
                    lastName: userData.lastName,
                    email: userData.email,
                    password: null,
                    confirmPassword: null,
                  }}
                >
                  <h3 className="text-black mt-4">
                    <strong>Basic info</strong>
                  </h3>
                  <Divider />
                  <Form.Item
                    name="firstName"
                    label="First Name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your first name",
                      },
                    ]}
                    hasFeedback
                  >
                    <Input size="large" placeholder="First name" type="text" />
                  </Form.Item>
                  <Form.Item
                    name="lastName"
                    label="Last Name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your last name",
                      },
                    ]}
                    hasFeedback
                  >
                    <Input size="large" placeholder="Last name" type="text" />
                  </Form.Item>
                  <Form.Item
                    name="email"
                    label="Email address"
                    rules={[
                      {
                        required: true,
                        message: "Please input your e-mail address",
                      },
                    ]}
                    hasFeedback
                  >
                    <Input
                      size="large"
                      placeholder="Email"
                      type="email"
                      disabled
                    />
                  </Form.Item>
                  <Button
                    type="primary"
                    size="large"
                    className="container-100"
                    htmlType="submit"
                    loading={loading}
                  >
                    <strong>{loading ? "Updating..." : "Update"}</strong>
                  </Button>
                </Form>
              </TabPane>
              <TabPane tab="Account Security" key="2">
                <Form
                  layout="vertical"
                  hideRequiredMark
                  onFinish={onPasswordFinish}
                  className="mb-4"
                  initialValues={{
                    password: null,
                    confirmPassword: null,
                  }}
                >
                  <h3 className="text-black mt-4">
                    <strong>Account security</strong>
                  </h3>
                  <Divider />
                  <Form.Item
                    name="password"
                    label="New Password"
                    rules={[
                      {
                        required: true,
                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
                        message:
                          "Please use 8 characters including small and capital letter, numbers and symbols",
                      },
                    ]}
                    hasFeedback
                  >
                    <Input.Password
                      size="large"
                      placeholder="Enter your new password"
                      autoComplete="off"
                    />
                  </Form.Item>
                  <Form.Item
                    name="confirmPassword"
                    label="Confirm Password"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(rule, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject("Password should match!");
                        },
                      }),
                      {
                        required: true,
                      },
                    ]}
                    dependencies={["password"]}
                    hasFeedback
                  >
                    <Input.Password
                      size="large"
                      placeholder="Re-enter your new password"
                      autoComplete="off"
                    />
                  </Form.Item>
                  <Button
                    type="primary"
                    size="large"
                    className="container-100"
                    htmlType="submit"
                    loading={loading}
                  >
                    <strong>{loading ? "Updating..." : "Update"}</strong>
                  </Button>
                </Form>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
      <Footer />
      <MobileFooter/>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { updateProfileAction })(Login);
